import React from 'react';
import Card from '@material-ui/core/Card';
import { ToggleButtonWrapper, StyledWrapper } from './ToggleButtonStyle';
import RiskFilter from '../FilterButton/RiskFilter';
import DefineQuery from '../../Filter/DefineQuery';
import FilterQueryCard from '../../Filter/FilterQueryCard';
import { useSelector, useDispatch } from 'react-redux';
import { pushShowGrid } from '../../../slices/ButtonsSlice';
import HeatLogo from '../../../assets/img/HeatMapgrid.svg';
import ListLogo from '../../../assets/img/RiskList.svg';
import { makeStyles } from '@material-ui/core';
import DropDownMenu from '../../Application/DropDownMenu/DropDownMenu';
const useStyles = makeStyles({
  card: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'space-between',
    height: '47px'
  },
  toggleButton: {
    display: 'flex',
    justifyContent: 'center'
  }
});

const ToggleButton = props => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const showApply = useSelector(state => state.buttonSlice.showApply);
  const applyEvent = useSelector(state => state.riskFilterSlice.applyEvent);
  const restrictValue = useSelector(state => state.buttonSlice.restrictValue);
  const showGrid = useSelector(state => state.buttonSlice.showGrid);
  const clickEvent = useSelector(state => state.applicationDrillHeatMap.clickEvent);
  const dashboardColumnData = useSelector(state => state.riskFilterSlice.dashboardColumnData);
  const drillColumnData = useSelector(state => state.riskFilterSlice.drillColumnData);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    elevation: 0,
    className: classes.card
  }, /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(RiskFilter, {
    totalCount: props.totalCount,
    risknextTableData: props.risknextTableData
  }), !showGrid ? /*#__PURE__*/React.createElement(DropDownMenu, {
    menuItems: clickEvent ? drillColumnData : dashboardColumnData,
    isRiskTable: true
  }) : /*#__PURE__*/React.createElement(React.Fragment, null)), /*#__PURE__*/React.createElement(ToggleButtonWrapper, null, !showApply && !restrictValue ? !applyEvent ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: () => dispatch(pushShowGrid(!showGrid)),
    className: classes.toggleButton
  }, showGrid ? /*#__PURE__*/React.createElement("img", {
    src: HeatLogo,
    alt: "heatLogo"
  }) : /*#__PURE__*/React.createElement("img", {
    src: ListLogo,
    alt: "ListLogo"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: () => dispatch(pushShowGrid(!showGrid)),
    className: classes.toggleButton
  }, showGrid ? /*#__PURE__*/React.createElement("img", {
    src: HeatLogo,
    alt: "heatLogo"
  }) : /*#__PURE__*/React.createElement("img", {
    src: ListLogo,
    alt: "ListLogo"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DefineQuery, null)))), !showApply && !restrictValue ? !applyEvent ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(FilterQueryCard, null) : /*#__PURE__*/React.createElement(FilterQueryCard, null));
};

export default ToggleButton;